'use client';

import { useI18n } from '@northladder/i18n';

import { IBaseInputCheckItem } from '../../types';

import { CheckInput } from './CheckInput';

type TInputCheckItemProps = Omit<IBaseInputCheckItem, 'locale'>;

/**
 * -----------------------------------------------------------------------------
 * This renders input check field to be used across all form fields.
 */
export function InputCheckItem({
  checked,
  label,
  name,
  onChange,
  required,
  title,
}: TInputCheckItemProps) {
  const { locale } = useI18n();

  return (
    <CheckInput
      checked={checked}
      label={label}
      locale={locale}
      name={name}
      onChange={onChange}
      required={required}
      title={title}
    />
  );
}
